import React from 'react';
import { CenterLoader } from '../CenterLoader';
import './FormSubmitOverlay.scss';

/**
 * Обгортка форми, яка блокує взаємодію та показує лоадер під час сабміту.
 *
 * Коли `submitting === true`:
 * - поверх форми рендериться напівпрозорий оверлей з {@link CenterLoader}
 * - `<fieldset>` переходить у стан `disabled`, що блокує всі інтерактивні елементи
 *
 * @param {object} props
 * @param {boolean} props.submitting — чи виконується сабміт зараз
 * @param {React.ReactNode} props.children — вміст форми (поля, кнопки тощо)
 * @returns {JSX.Element}
 *
 * @example
 * <FormSubmitOverlay submitting={isLoading}>
 *   <CFormInput name="title" />
 *   <CButton type="submit">Зберегти</CButton>
 * </FormSubmitOverlay>
 */
const FormSubmitOverlay = ({ submitting, children }) => (
	<div className="form-overlay-wrapper">
		{submitting && (
			<div className="form-overlay">
				<CenterLoader color="success" />
			</div>
		)}
		<fieldset disabled={submitting} className="form-overlay-fieldset">
			{children}
		</fieldset>
	</div>
);

export default FormSubmitOverlay;
